import { useEffect, useMemo, useRef, useState } from 'react'
import { WSClient, WSStatus } from '../lib/ws'

// Module-level singleton so NavBar + Inbox reuse one connection
let sharedClient: WSClient | null = null

export function useInboxWS() {
  const clientRef = useRef<WSClient | null>(null)
  if (!clientRef.current) {
    if (!sharedClient) {
      sharedClient = new WSClient({ path: '/ws/inbox/', authAsQuery: true })
    }
    clientRef.current = sharedClient
  }
  const client = clientRef.current

  const [status, setStatus] = useState<WSStatus>(client.getStatus())
  const [lastUpdate, setLastUpdate] = useState<number>(0)

  useEffect(() => {
    const offStatus = client.on('status', (s) => setStatus(s as WSStatus))
    const offThreadUpdate = client.on('thread:update', () => setLastUpdate(Date.now()))
    const offNotifNew = client.on('notification:new', () => setLastUpdate(Date.now()))
    const offFatal = client.on('fatal', () => {})
    client.connect()
    const vis = () => {
      if (document.visibilityState === 'hidden') {
        client.close()
      } else {
        client.connect() // reconnect when tab returns
      }
    }
    document.addEventListener('visibilitychange', vis)
    return () => {
      offStatus()
      offThreadUpdate()
      offNotifNew()
      offFatal()
      document.removeEventListener('visibilitychange', vis)
      // do not close here; shared instance is reused across hooks
    }
  }, [client])

  const send = useMemo(() => (msg: any) => client.send(msg), [client])
  return { status, lastUpdate, send }
}
